
import { apiConstants } from "../../shared/config";
import work from "./type";
const code = apiConstants.code;
const baseRouteName = `${code}.${work.key}_`;

export const type = work.key;
export const routes = {
    path: `/${code}/${work.basePath}`,
    component: () => import ( /* webpackChunkName: "gimgestao-other_occupations" */ './views/OtherOccupationsBase.vue'),
    children: [
        {
            path: `home`,
            name: `${code}.${work.basePath}.home`,
            component: () => import ( /* webpackChunkName: "gimgestao" */ './views/Home.vue'),
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'Home',
            }
        },
        {
            path: `type_global`,
            component: () => import( /* webpackChunkName: "gimgestao-type" */ './views/typeGlobal/TypeBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}type_global`,
                    component: () => import( /* webpackChunkName: "gimgestao-type" */ './views/typeGlobal/TypeList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Tipos Global',
                    }
                },
                {
                    path: 'add',
                    name: `${baseRouteName}type_global.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-type" */ './views/typeGlobal/TypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Tipo Global',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}type_global.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-type" */ './views/typeGlobal/TypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Tipo Global',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'Tipo Global',
            }
        },
        {
            path: `status_global`,
            component: () => import( /* webpackChunkName: "gimgestao-status" */ './views/statusGlobal/StatusBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}status_global`,
                    component: () => import( /* webpackChunkName: "gimgestao-status" */ './views/statusGlobal/StatusList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Estados Global',
                    }
                },
                {
                    path: 'add',
                    name: `${baseRouteName}status_global.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-status" */ './views/statusGlobal/StatusDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Estado Global',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}status_global.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-status" */ './views/statusGlobal/StatusDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Estado Global',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'Estado Global',
            }
        },
    ],
    meta: {
        auth: undefined,
        hideHeaderName: true,
        title: 'Outras Ocupações',
    }
};

export default routes;
